import React from 'react';
import numberFormatter from '../../utils/numberFormatter.js';
import moment from 'moment';
import Dropdown from './Dropdown.jsx'
import QueryStringService from '../../services/queryStringService.js';

export default class CampaignSummaryPosting extends React.Component {
    constructor() {
        super();
        this.queryStringService = new QueryStringService();
        this.country = this.queryStringService.getCurrentCountry();
        this.state = {
        };
    }

    render() {
        let colorClass = "posting-background";
        let statusText = "Posting ";
        let target = this.props.selectedData.target;
        let postingStatusTime = "";

        if (this.props.selectedData.postingStatus === 'NotStarted') {
            statusText = statusText + 'Not Started';
        } else {
            statusText = statusText + this.props.selectedData.postingStatus;
        }

        postingStatusTime = "(" + moment(this.props.selectedData.postingStatusTime).format('YYYY-MM-DD HH:mm') + ")";
        let achived = Math.round((this.props.selectedData.successfulPostings / target) * 100);
        let ongoingClass = this.props.selectedData.postingStatus === 'Ongoing' ? 'checked' : '';
        let achivedClass = this.props.selectedData.postingStatus === 'Finished' && achived >= this.props.parameters.postingSuccessLimit ? 'checked' : '';
        let notAchivedClass = this.props.selectedData.postingStatus === 'Finished' && achived < this.props.parameters.postingSuccessLimit ? 'checked' : '';

        let postingDates = this.props.postingPeriods.map((x) => {
            return { name: 'W' + moment(x).format('WW') + ' - ' + moment(x).format('YYYY-MM-DD'), value: x, selected: x === this.props.selectedData.postingDate }
        });


        //default is SE texts and link
        let termsText = "Clear Channel Outdoor guarantees 97% delivery according to our terms and conditions:";
        let termsLinkText = "www.clearchannel.se/allmanna-forsaljningsvillkor/";
        let termsLink = "https://www.clearchannel.se/allmanna-forsaljningsvillkor/";
        switch (this.country) {
            case "no":
                termsText = "Clear Channel Outdoor guarantees 95% delivery according to our standard Terms of Purchase of Goods:";
                termsLinkText = "www.clearchannel.no/avtalevilkar/";
                termsLink = "https://www.clearchannel.no/avtalevilkar/";
                break;
            case "dk":
                termsText = "Clear Channel guarantees 95% delivery according to our Business Terms & Conditions:";
                termsLinkText = "www.clearchannel.dk/forretnings-og-handelsbetingelser/";
                termsLink = "https://www.clearchannel.dk/forretnings-og-handelsbetingelser/";
                break;
            default:
        }

        return (
            <div>
                <div className={'campaign-summary-posting ' + colorClass}>
                    <table>
                        <tbody>
                            {postingDates.length > 1 &&
                        <tr>
                            <th>
                                Posting Date</th>
                            <td>
                            <Dropdown
                                list={postingDates}
                                customClass={colorClass}
                                onSelect={(item) => this.props.onSelectPostingDate(item.value)}
                                    />
                            </td>
                                </tr>
                            }
                        <tr>
                            <th>
                                <h3 style={{ marginBottom: "0px" }}>Status</h3></th>
                            <td>
                                <h3 style={{ marginBottom: "0px" }}>{statusText}</h3></td>
                        </tr>
                        <tr>
                            <th></th>
                            <td><h5 style={{ marginTop: "0px" }}>{postingStatusTime}</h5></td>
                        </tr>
                        {target > 0 &&
                        <tr>
                            <th>Posting Estimate</th>
                                <td>{numberFormatter.numberWithSpaces(target)}</td>
                            </tr>
                            }
                        <tr>
                            <th>Posted</th>
                                <td>{numberFormatter.numberWithSpaces(this.props.selectedData.successfulPostings)}</td>
                            </tr>
                        <tr>
                            <th>Ongoing</th>
                            <td>{numberFormatter.numberWithSpaces(this.props.selectedData.ongoingPostings)}</td>
                        </tr>
                        <tr>
                            <th>Achieved</th>
                            <td>{achived}%</td>
                        </tr>
                        </tbody>
                    </table>
                    <div className="posting-info-text">
                        Posting is conducted from Sunday 18:00 to Tuesday 23:59<br /><br />
                        {termsText}
                        <a href={termsLink} style={{ color: 'white' }} target="_blank"> {termsLinkText}</a>
                    </div>
                    <div className="row">
                        <div className="col-md-4 result-dot" >
                            <div className={'dot ' + ongoingClass} ></div>
                            <div className="dot-text">Ongoing</div>
                        </div>
                        <div className="col-md-4 result-dot" >
                            <div className={'dot ' + achivedClass} ></div>
                            <div className="dot-text">Accomplished</div>
                        </div>
                        <div className="col-md-4 result-dot" >
                            <div className={'dot ' + notAchivedClass} ></div>
                            <div className="dot-text">Not accomplished</div>
                        </div>
                    </div>
                </div>
            </div>

        );
    }
}